import ProtectionBlock from './ProtectionBlock'

export default ProtectionBlock
